var map = {
	"./Arabic_Chart.svg": "7884",
	"./ChatDubble-ar.svg": "4d75",
	"./ChatDubble.svg": "e7ae",
	"./Group 1.svg": "706c",
	"./UpdownArrow.png": "b6fe",
	"./UpdownArrow.svg": "0b35",
	"./africa-lg.svg": "ab05",
	"./africa-stats.svg": "b2d4",
	"./africa.svg": "f10d",
	"./al-wazaan-signature.svg": "d700",
	"./cardWorld.svg": "e0ce",
	"./certificate.svg": "a007",
	"./chart.svg": "1446",
	"./chartCircle.svg": "f868",
	"./chartImg.svg": "f335",
	"./chart_ar.png": "90e2",
	"./chart_ar.svg": "2ab2",
	"./chatArrow.svg": "cc09",
	"./circle.svg": "e8e5",
	"./convergence.svg": "e12a",
	"./country-morocco.svg": "1a75",
	"./country-southsudan.svg": "1766",
	"./country-sudan.svg": "b8ae",
	"./cross.svg": "42db",
	"./customer-stisfication.svg": "8096",
	"./digital-chart - Copy.svg": "7971",
	"./digital-chart.svg": "912a",
	"./digital-chart_ar.svg": "3201",
	"./digitization-arrow-icon.svg": "bf8d",
	"./digitization-groth.svg": "2f56",
	"./digitization-network.svg": "59d4",
	"./digitization-population.svg": "3427",
	"./digitization-total-trafic.svg": "4c22",
	"./dollerImg.svg": "9693",
	"./enterprise.svg": "d07f",
	"./globe.svg": "24ec",
	"./hand-drag.svg": "ec18",
	"./handIcon.svg": "ffc6",
	"./health.svg": "0035",
	"./ict.svg": "39a4",
	"./logo.svg": "a8bf",
	"./mblIcon.svg": "c094",
	"./menu.svg": "b28f",
	"./menuicon.svg": "34bb",
	"./meter.svg": "3a62",
	"./middle-east-lg.svg": "8d8f",
	"./middle-east-stats.svg": "7374",
	"./middle-east.svg": "0f69",
	"./minus.svg": "2595",
	"./optimazation.svg": "35a5",
	"./peoples.svg": "a2c1",
	"./plus.svg": "0205",
	"./right-arrow.svg": "66ba",
	"./risk-management-graphic.svg": "17be",
	"./search.svg": "2845",
	"./signals.svg": "2436",
	"./tech.svg": "486a",
	"./threeUsers.svg": "18e7",
	"./tik.svg": "3ce5",
	"./tower.svg": "fb71",
	"./towercus.svg": "5cc6",
	"./vectorsHuman.svg": "7da7",
	"./worldIcon.svg": "ee8f",
	"./worldMap.svg": "c4cd",
	"./year-digit.svg": "dce0",
	"./year.svg": "3d7b",
	"./zain-bahrain.svg": "f9f3",
	"./zain-iraq.svg": "ad43",
	"./zain-jordan.svg": "dcdb",
	"./zain-ksa.svg": "ac6a",
	"./zain-kuwait.svg": "fbaa"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "af8c";